<template>
  <div>
    <ul id="course" class="course mt-6 px-4 py-6">
      <li>
        <plan-station
          :editable="editable"
          :station="departure"
          :route="routes[0]"
          :routeIndex="0"
          :showDepartureModal="() => showModal('departure')" />
      </li>
      <li v-for="route in routes" v-bind:key="route.index">
        <template v-if="sections !== undefined">
          <plan-banner
            :editable="editable"
            :tickets="sections[route.index]" />
        </template>
        <div class="route" :class="editable ? 'pb-6' : 'pb-10'">
          <add-place
            :editable="editable"
            :newPlaceFromMap="() => newPlaceFromMap(route)"
            :newPlace="() => showModal('place', { route: route })" />
          <route :route="route" :editable="editable" />
          <div v-if="editable" class="plan-route-change pt-2 pr-2 text-right relative">
            <a @click="changeRoute(route.index)" class="plan-route-change-btn">
              <span>{{ $t('tour_change_route') }}</span>
            </a>
          </div>
        </div>
        <plan-place
          v-if="destinations[route.index]"
          :routeIndex="route.index + 1"
          :editable="editable"
          :place="destinations[route.index]"
          :route="route"
          :next="routes[route.index + 1]"
          :changeVisit="() => showModal('time', { destination: destinations[route.index], route: route })"
          :deleteDestination="() => deleteDestination(destinations[route.index])" />
      </li>
      <li>
        <plan-station
          :isDeparture=false
          :editable="editable"
          :station="arrival"
          :route="routes.slice(-1)[0]"
          :routeIndex="routes.length"
          :showDepartureModal="() => showModal('arrival')" />
      </li>
    </ul>
    <plan-modal
      v-if="editable"
      v-show="modal.show"
      :closeModal="() => closeModal()"
      :modals=modals
      :kind=modal.kind
      :target=modal.target />
    <div v-if="showChangeRoute">
      <Change-Route
        :changeRouteIndex="changeRouteIndex"
        @closeChangeRoute="closeChangeRoute" />
    </div>
  </div>
</template>

<script>
import PlanPlace from "../molecules/PlanPlace"
import PlanStation from "../molecules/PlanStation"
import PlanModal from "../molecules/PlanModal"
import Route from "../molecules/Route"
import Departure from "../molecules/Departure"
import Arrival from "../molecules/Arrival"
import Time from "../molecules/Time"
import NewPlace from "../molecules/NewPlace"
import AddPlace from "../molecules/AddPlace"
import PlanBanner from "../molecules/PlanBanner"
import ChangeRoute from "../molecules/ChangeRoute"
import { mapGetters } from 'vuex'

export default {
  components: {
    PlanPlace,
    PlanStation,
    PlanModal,
    Route,
    AddPlace,
    PlanBanner,
    ChangeRoute
  },
  props: {
    editable: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  data () {
    return {
      places: [],
      modal: {
        show: false,
        kind: 'departure',
        target: undefined
      },
      showChangeRoute: false,
      changeRouteIndex: undefined
    }
  },
  methods: {
    closeModal: function () {
      this.modal.show = false
    },
    showModal: function (kind, target = {}) {
      this.modal.show = true
      this.modal.kind = kind
      this.modal.target = target
    },
    setDeparture: function (station) {
      this.$store.dispatch('destinations/updateDepartureStation', station.Name)
      this.$store.dispatch('destinations/updateDepartureStationCode', station.code)
      this.modal.show = false
      this.$store.dispatch('routes/search')
    },
    setArrival: function (station) {
      this.$store.dispatch('destinations/updateArrivalStation', station.Name)
      this.$store.dispatch('destinations/updateArrivalStationCode', station.code)
      this.modal.show = false
      this.$store.dispatch('routes/search')
    },
    deleteDestination: function (destination) {
      this.$store.dispatch('destinations/deleteDestination', destination)
      this.$store.dispatch('routes/search')
    },
    timeUpdate: function (destination, time, arrivalTime) {
      const params = {
        destination: destination,
        visit: time,
        arrivalTime: arrivalTime
      }
      this.$store.dispatch('destinations/updateTime', params)
      this.modal.show = false
      this.$store.dispatch('routes/search')
    },
    addPlace: function (route, time, place) {
      // GoogleAnalytics
      this.$gtag.event("プランにPOI追加", {
        poi_name: place.name
      });
      if (place.genreIds.indexOf('TH6_tag159') != -1) {
        this.$store.dispatch('destinations/spliceDestinationLock', { route: route, visit: time, place: place })
        this.$store.dispatch('destinations/setStay', { route: route})

      } else {
        this.$store.dispatch('destinations/spliceDestination', { route: route, visit: time, place: place })
      }

      this.modal.show = false
      this.$store.dispatch('routes/search')
    },
    newPlaceFromMap: function (route) {
      this.$router.push({ name: 'map', params: { lang: this.$store.getters['user/getLang'], route: route }})
    },
    changeRoute: function (index) {
      this.changeRouteIndex = index
      this.showChangeRoute = true
    },
    closeChangeRoute: function () {
      this.showChangeRoute = false
    }
  },
  computed: {
    ...mapGetters({
      departure: 'destinations/getDepatureStation',
      arrival: 'destinations/getArrivalStation',
      routes: 'routes/getAll',
      destinations: 'destinations/getAll',
      sections: 'tickets/getAll',
    }),
    modals: function () {
      return {
        'departure' : {
          callback: (name) => this.setDeparture(name),
          component: Departure
        },
        'arrival' : {
          callback: (name) => this.setArrival(name),
          component: Arrival
        },
        'time' : {
          callback: (destination, time, arrivalTime) => this.timeUpdate(destination, time, arrivalTime),
          component: Time
        },
        'place' : {
          callback: (index, time, place) => this.addPlace(index, time, place),
          component: NewPlace
        }
      }
    },
    isError: function () {
      return this.$store.getters['routes/isError']
    },
    departureTime: function () {
      return this.routes[0] && this.routes[0].departureTime
    },
    arrivalTime: function () {
      return this.routes.slice(-1)[0] && this.routes.slice(-1)[0].arrivalTime
    }
  },
  watch: {
    isError: function (val)  {
      const m = this.$t('tour_not_found_route_message')
      if (val) this.$alert({ message: m })
    }
  }
}
</script>
